import {
    SET_SELECTED_SUITES, CLEAR_SELECTED_SUITES,
  } from './constants'
  
  export const setSelectedSuites = (payload) => ({
    type: SET_SELECTED_SUITES,
    payload
  })

  export const clearSelectedSuites = () => ({
    type: CLEAR_SELECTED_SUITES,
  })
